import React from 'react';
import { motion } from "motion/react";
import { PageTransitions } from '../../../../utils/transitions';


const EdgePageFrame: React.FC<{ children: any, className?: string }> = ({ children, className }) => {
    return (
        <motion.div
            variants={PageTransitions}
            initial='initial'
            animate='animate'
            exit='exit'
            className={'w-full flex flex-col grow py-6 justify-center items-center relative overflow-hidden ' + className || ''}
        >
            {children}
            <div className={'absolute top-0 left-0 size-full -z-10 pointer-events-none'}>
                <img
                    src={'/edge/bg/wooden-floor-background.jpg'}
                    className='object-cover size-full opacity-30'
                />
            </div>
        </motion.div>
    )
}

export default EdgePageFrame;